module.exports = __webpack_public_path__ + "static/media/arryn_power.5aeba3e5.png";